const css = `._6cjjbG__middot{margin-left:6px;margin-right:6px;display:inline-block}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"middot":"_6cjjbG__middot"};
